import React, { memo } from 'react';
import { convertPriceDisplay } from 'common/PriceConverter';
import { Hr } from 'components/atoms/Hr';
import { Item } from 'requests/RequestPayment';
import classes from './bulk-payment-item.module.scss';

type Props = {
	items: Item[];
};
export const BulkPaymentItem = memo((props: Props) => {
	const { items } = props;

	return (
		<div className={classes.items}>
			{items.map((item, i) => {
				return (
					<>
						{i !== 0 && (
							<div className={classes.paymentOverviewHr}>
								<Hr />
							</div>
						)}
						<div className={classes.item}>
							<div className={classes.itemTitle}>{item.title}</div>
							{!!item.application_period && (
								<div className={classes.itemApplicationPeriod}>{item.application_period}</div>
							)}
							<div className={classes.itemContents}>
								<div className={classes.itemImageAndId}>
									{!!item.image_url && <img className={classes.itemImage} src={item.image_url} alt="イメージ"></img>}
									{!!item.id && <p className={classes.itemId}>{`商品ID:${item.id}`}</p>}
								</div>
								<div className={classes.itemDetailWrap}>
									{item.detail.map((d) => {
										return (
											<div className={classes.itemDetail}>
												<div className={classes.detailKey}>{d.key}</div>
												<div className={classes.detailValue}>{d.is_price ? convertPriceDisplay(d.value) : d.value}</div>
											</div>
										);
									})}
									<div className={classes.subtotal}>
										<div className={classes.subtotalKey}>{item.subtotal.key}</div>
										<div className={classes.subtotalValue}>{convertPriceDisplay(item.subtotal.value)}</div>
									</div>
								</div>
							</div>
						</div>
					</>
				);
			})}
		</div>
	);
});
